import PurchasesControlPanel from './PurchasesControlPanel';

export default PurchasesControlPanel;
